module.exports = "<p>dashboard works!</p>\n"